import { render, staticRenderFns } from "./CandidatesPaymentsEditor.vue?vue&type=template&id=0b10203a&lang=pug"
import script from "./CandidatesPaymentsEditor.vue?vue&type=script&lang=js"
export * from "./CandidatesPaymentsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports